import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import moment from "moment";
import {
  Grid,
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import { toast } from "react-toastify";
import Layout from "../../wrapper";
import Loader from "../../Layout/Loader";
import TextField from "../../Components/common/TextField";
import MenuItem from "../../Components/common/MenuItem";
import Button from "../../Components/common/Button";
import CommonTable from "../../Components/common/tableWithBackEndPagination";
import instance from "../../axios";
import withRoutes from "../../HOC/HocRoutes";
import { logInUserInfo } from "../../Actions/Users";
import ConfirmDialoag from "../../Components/common/ConfirmDialoag";
import ExportImportMenu from "../../Components/common/ExportImportMenu";

let listSource;
let detailSource;

const entityOptions = [
  { name: "Vehicle", value: "vehicle" },
  { name: "Service", value: "service" },
  { name: "Account", value: "account" },
];

const serverOptions = [
  { name: "Dex", value: "dex" },
  { name: "Mac", value: "mac" },
];

class VehicleStatusLogs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      pageSize: 20,
      searchText: "",
      entity: "",
      serverName: "",
      listData: {},
      loader: false,
      expandedHistoryId: null,
      detailCache: {},
      detailLoadingId: null,
      isResend: false,
      selectedRow: null,
    };
  }

  componentDidMount() {
    this.fetchIntegrationLogs();
  }

  componentWillUnmount() {
    listSource?.cancel?.();
    detailSource?.cancel?.();
  }

  formatCreatedDate = (value) => {
    if (!value) return value;
    const { twelveHourFormat } = this.props.logInUser || {};
    return twelveHourFormat
      ? moment(value).format("YYYY-MM-DD hh:mm A")
      : moment(value).format("YYYY-MM-DD HH:mm");
  };

  formatPayload = (value) => {
    if (!value) return "-";

    const decoded = String(value)
      .replace(/&#34;/g, '"')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&amp;/g, "&");

    try {
      return JSON.stringify(JSON.parse(decoded), null, 2);
    } catch {
      return decoded;
    }
  };

  formatHistoryDetail = (item = {}) => ({
    ...item,
    payload: this.formatPayload(item.payload),
    response: item.response || "-",
    serverName: item.serverName || "-",
    created: this.formatCreatedDate(item.created),
  });

  formatRows = (rows = []) =>
    rows.map((row) => ({
      ...row,
      created: this.formatCreatedDate(row.created),
    }));

  getHistoryQueryParams = ({ includePagination = true } = {}) => {
    const { page, pageSize, searchText, entity, serverName } = this.state;
    const params = new URLSearchParams();

    if (includePagination) {
      params.append("page", page);
      params.append("limit", pageSize);
    }

    if (searchText) {
      params.append("search", searchText);
    }
    if (entity) {
      params.append("entity", entity);
    }
    if (serverName) {
      params.append("serverName", serverName);
    }

    return params;
  };

  fetchIntegrationLogs = () => {
    const params = this.getHistoryQueryParams({ includePagination: true });

    listSource?.cancel?.();
    listSource = axios.CancelToken.source();

    this.setState({ loader: true });

    instance
      .get(`/api/integrationlogs/vehiclestatuslog/get?${params.toString()}`, {
        cancelToken: listSource.token,
      })
      .then((res) => {
        this.setState({
          listData: {
            ...res,
            data: this.formatRows(res?.data || []),
          },
          loader: false,
          expandedHistoryId: null,
        });
      })
      .catch((error) => {
        if (error?.statusCode === "440") {
          this.props.navigate("/logout");
        }
        this.setState({ loader: false });
      });
  };

  downloadHistoryExcel = () => {
    const params = this.getHistoryQueryParams({ includePagination: false });
    const query = params.toString();
    const url = `/api/integrationlogs/export/history${query ? `?${query}` : ""}`;

    axios({
      method: "GET",
      url,
      headers: {
        Accept:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      responseType: "blob",
    })
      .then((response) => {
        const link = document.createElement("a");
        const downloadUrl = window.URL.createObjectURL(
          new Blob([response.data]),
        );
        link.setAttribute(
          "download",
          `integration_logs_${moment().format("YYYYMMDD_HHmmss")}.xlsx`,
        );
        document.body.appendChild(link);
        link.href = downloadUrl;
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
      })
      .catch(() => {
        toast.error(this.props.translate("somethingWentWrong"));
      });
  };

  sendHistoryEmail = () => {
    const params = this.getHistoryQueryParams({ includePagination: false });
    params.append("sendEmail", "true");
    const query = params.toString();
    const url = `/api/integrationlogs/export/history${query ? `?${query}` : ""}`;

    axios({
      method: "GET",
      url,
      headers: {
        Accept:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
    })
      .then((response) => {
        const payload = response?.data;
        const isSuccess =
          response.status === 200 &&
          (!payload ||
            typeof payload !== "object" ||
            !payload.status ||
            payload.status === "success" ||
            payload.statusCode === "200" ||
            payload.statusCode === 200);

        if (isSuccess) {
          toast.success(this.props.translate("emailSentSuccessfully"));
        } else {
          toast.error(this.props.translate("somethingWentWrong"));
        }
      })
      .catch(() => {
        toast.error(this.props.translate("somethingWentWrong"));
      });
  };

  fetchHistoryDetail = (historyId) => {
    if (!historyId || this.state.detailCache[historyId]) {
      return;
    }

    detailSource?.cancel?.();
    detailSource = axios.CancelToken.source();

    this.setState({ detailLoadingId: historyId });

    instance
      .get(`/api/integrationlogs/history/get?historyId=${historyId}`, {
        cancelToken: detailSource.token,
      })
      .then((res) => {
        let items = [];
        if (Array.isArray(res)) {
          items = res;
        } else if (Array.isArray(res?.data)) {
          items = res.data;
        } else if (res && typeof res === "object") {
          items = [res];
        }

        this.setState((prevState) => ({
          detailCache: {
            ...prevState.detailCache,
            [historyId]: items.map((item) => this.formatHistoryDetail(item)),
          },
          detailLoadingId: null,
        }));
      })
      .catch((error) => {
        if (error?.statusCode === "440") {
          this.props.navigate("/logout");
        } else {
          toast.error(this.props.translate("somethingWentWrong"));
        }
        this.setState({ detailLoadingId: null });
      });
  };

  handleResend = (row) => {
    this.setState(
      { isResend: false, selectedRow: null },
      () => {
        this.setState({
          isResend: true,
          selectedRow: row,
        });
      },
    );
  };

  onCancelResend = () => {
    this.setState({
      isResend: false,
      selectedRow: null,
    });
  };

  submitResend = () => {
    const { selectedRow } = this.state;
    const resendId = selectedRow?.historyId || selectedRow?.id;

    if (!resendId) {
      toast.error(this.props.translate("somethingWentWrong"));
      this.setState({ isResend: false, selectedRow: null });
      return;
    }

    const url = `/api/integrationlogs/resend/${resendId}`;

    instance
      .get(url)
      .then(() => {
        toast.success(this.props.translate("entityResend"));
        this.setState({ isResend: false, selectedRow: null }, () => {
          this.fetchIntegrationLogs();
        });
      })
      .catch((err) => {
        if (err?.response?.status === 440) {
          this.props.navigate("/logout");
        } else {
          toast.error(this.props.translate("somethingWentWrong"));
        }
        this.setState({ isResend: false, selectedRow: null });
      });
  };

  handleToggleRow = (historyId) => {
    const { expandedHistoryId } = this.state;

    if (expandedHistoryId === historyId) {
      this.setState({ expandedHistoryId: null });
      return;
    }

    this.setState({ expandedHistoryId: historyId }, () => {
      this.fetchHistoryDetail(historyId);
    });
  };

  handleRowClick = (row) => {
    const historyId = row?.historyId || row?.id;
    this.handleToggleRow(historyId);
  };

  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.value });
  };

  handleSearch = () => {
    this.setState({ page: 1 }, this.fetchIntegrationLogs);
  };

  handleReset = () => {
    this.setState(
      {
        searchText: "",
        entity: "",
        serverName: "",
        page: 1,
        detailCache: {},
        expandedHistoryId: null,
      },
      this.fetchIntegrationLogs,
    );
  };

  handleChangeRowsPerPage = (value) => {
    this.setState(
      {
        page: 1,
        pageSize: value,
        detailCache: {},
        expandedHistoryId: null,
      },
      this.fetchIntegrationLogs,
    );
  };

  handleChangePage = (value) => {
    this.setState(
      {
        page: value,
        detailCache: {},
        expandedHistoryId: null,
      },
      this.fetchIntegrationLogs,
    );
  };

  checkFloatNumber = (value) => Number(value) === value && value % 1 !== 0;

  setPagination = () => {
    const pagination = { ...this.state.listData };
    const lastPage = pagination.total / this.state.pageSize;
    const isFloat = this.checkFloatNumber(lastPage);

    delete pagination.data;

    return {
      ...pagination,
      page: this.state.page,
      pageSize: this.state.pageSize,
      lastPage: isFloat ? parseInt(lastPage + 1, 10) : lastPage || 1,
    };
  };

  getRowDefinition = () => {
    const { translate } = this.props;
    return [
      { id: "plateNo", label: translate("plateNumber") },
      { id: "vinNo", label: translate("vin") },
      { id: "createdTime", label: translate("createdDate") },
      { id: "statusSent", label: translate("status") },
      { id: "status", label: translate("action") },

    ];
  };

  render() {
    const { logInUser, translate, themecolors } = this.props;
    const {
      loader,
      listData,
      searchText,
      entity,
      serverName,
      expandedHistoryId,
      detailCache,
      detailLoadingId,
    } = this.state;

    if (!logInUser) {
      fetch(
        "/api/session?app=3b8d4deb84c0d9b65070c872e2f73626f23d8dc8789a7a05",
        {
          headers: { Accept: "application/json; odata=verbose" },
        },
      )
        .then((response) => {
          if (response.ok) {
            response.json().then((res) => {
              if (res.status === "success") {
                const userInfo = res.data;
                this.props.setActiveLanguage(
                  userInfo?.attributes?.lang || "en",
                );
                this.props.dispatch(logInUserInfo(userInfo));
              } else if (res?.statusCode === "440") {
                window.location.replace("/login");
              } else if (res.statusCode) {
                const err = res?.message.split(":");
                err[1] = err[1].replace(")", "");
                toast.error(this.props.translate(err[1]));
                this.props.navigate("/login");
              }
            });
          } else {
            this.props.navigate("/login");
            throw response;
          }
        })
        .catch(() => {
          toast.error("somethingWentWrong");
        });
      return null;
    }

    return (
      <Layout {...this.props} {...this.state}>
        <Grid container alignItems="center" sx={{ mb: 2 }}>
          <Grid item xs={3}>
            <h4>{translate("vehicleStatusLogs")}</h4>
          </Grid>
          <Grid
            item
            xs={9}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: 2,
            }}
          >
            <TextField
              label={translate("search")}
              value={searchText}
              onChange={this.handleChange("searchText")}
              sx={{ width: 220 }}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={this.handleSearch}
            >
              {translate("search")}
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              disabled={!entity && !serverName && !searchText}
              onClick={this.handleReset}
            >
              {translate("reset")}
            </Button>
            {/* <div style={{ minWidth: 120 }}>
              <ExportImportMenu
                fileName="vehicleStatusLogs"
                isServices
                translate={translate}
                themecolors={themecolors}
                noPdf
                onDownload={this.downloadHistoryExcel}
                onSendEmail={this.sendHistoryEmail}
              />
            </div> */}
          </Grid>
        </Grid>

        {loader ? (
          <Loader />
        ) : (
          <>
            <CommonTable
              rows={listData?.data || []}
              pagination={this.setPagination()}
              handleChangeRowsPerPage={this.handleChangeRowsPerPage}
              handleChangePage={this.handleChangePage}
              rowDefinition={this.getRowDefinition()}
              isIntegrationLogs
              isEditable
              isSystem
              handleResend={this.handleResend}
              onClick={this.handleRowClick}
              onToggleExpandRow={this.handleRowClick}
              expandableRows
              expandedRowId={expandedHistoryId}
              renderExpandedRow={(row) => {
                const historyId = row?.historyId || row?.id;
                const detailRows = detailCache[historyId] || [];
                return (
                  <Box sx={{ backgroundColor: "#fafafa" }}>
                    {detailLoadingId === historyId ? (
                      <Loader />
                    ) : detailRows.length ? (
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell>{translate("payload")}</TableCell>
                            <TableCell>{translate("response")}</TableCell>
                            <TableCell>{translate("serverName")}</TableCell>
                            <TableCell>{translate("createdDate")}</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {detailRows.map((item, index) => (
                            <TableRow key={`${historyId}-${index}`}>
                              <TableCell
                                sx={{
                                  whiteSpace: "pre-wrap",
                                  wordBreak: "break-word",
                                  verticalAlign: "top",
                                  fontFamily: "monospace",
                                  fontSize: 12,
                                  width: "40%",
                                }}
                              >
                                {item.payload || "-"}
                              </TableCell>
                              <TableCell
                                sx={{ verticalAlign: "top", width: "25%" }}
                              >
                                {item.response || "-"}
                              </TableCell>
                              <TableCell
                                sx={{ verticalAlign: "top", width: "15%" }}
                              >
                                {item.serverName || "-"}
                              </TableCell>
                              <TableCell
                                sx={{ verticalAlign: "top", width: "20%" }}
                              >
                                {item.created || "-"}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    ) : (
                      <Typography variant="body2" color="text.secondary">
                        {translate("noDataFound")}
                      </Typography>
                    )}
                  </Box>
                );
              }}
              themecolors={themecolors}
              isCursoPointer
            />
          </>
        )}
        {this.state.isResend && (
          <ConfirmDialoag
            key={this.state.selectedRow?.historyId || this.state.selectedRow?.id}
            onCancel={this.onCancelResend}
            onOk={this.submitResend}
            title={translate("areYouWantToResend")}
            children={
              this.state.selectedRow?.entity || this.state.selectedRow?.entityId
            }
          />
        )}
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  logInUser: state.logInUsers,
  themecolors: state.themecolors,
  ServerSetting: state.ServerSetting,
});

export default connect(mapStateToProps)(withRoutes(VehicleStatusLogs));
